<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <router-view v-if="tab.route === activeTab" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Warehouse',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { tabMenu: 'menu.inventory.read', name: 'Inventory', route: `/warehouse/inventory`, roles: ['manager', 'stockmanager', 'buyer'] },
        { tabMenu: 'menu.inventory.capture', name: 'CaptureInventory', route: `/warehouse/capture-inventory`, roles: ['manager', 'stockmanager', 'buyer', 'chef'] },
        { tabMenu: 'Salida de inventario', name: 'Decrease', route: `/warehouse/decrease`, roles: ['manager', 'stockmanager', 'chef'] },
        { tabMenu: 'menu.inventory.trackProducts', name: 'TrackingProducts', route: `/warehouse/tracking-products`, roles: ['manager', 'stockmanager', 'buyer'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    },
    area () {
      return this.$route.params.area
    }
  }
}
</script>
